import React from "react";

const WhyChooseUs = () => {
  const features = [
    {
      imgSrc: "/assets/images/trusted.png", 
      title: "CERTIFIED DIAMOND JEWELRY",
    },
    {
      imgSrc: "/assets/images/trust.png", 
      title: "TRUSTED BY TRUSTPILOT",
    },
    {
      imgSrc: "/assets/images/24_7support.png", 
      title: "24X7 CUSTOMER SERVICE",
    },
    {
      imgSrc: "/assets/images/services-3_85x.png", 
      title: "SECURED PAYMENTS",
    },
  ];

  return (
    <div className="container mx-auto my-12">
      <h2 className="text-3xl font-semibold text-center mb-8">
        <span className="border-b-2 border-red-600 pb-2">Why Choose Wellstar?</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
        {features.map((feature, index) => (
          <div key={index} className="flex flex-col items-center gap-4">
            <div className="bg-gray-100 rounded-full w-20 h-20 flex items-center justify-center shadow-md">
              <img
                src={feature.imgSrc}
                alt={feature.title}
                className="w-10 h-10"
              />
            </div>
            <p className="text-sm font-bold uppercase">{feature.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseUs;
